function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Stack } from '../../Stack';
import React, { useMemo } from 'react';
import { SearchDropdown } from '../../Search';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const YearRangeSelect = props => {
  var _props$value2, _props$value4;
  const generateYears = (min, max) => {
    const years = [];
    for (let i = max; i >= min; i--) {
      years.push(i);
    }
    return years;
  };
  const yearsFrom = useMemo(() => {
    var _props$value$to, _props$value;
    return generateYears(props.min, (_props$value$to = (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.to) !== null && _props$value$to !== void 0 ? _props$value$to : props.max).reverse();
  }, [(_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.to]);
  const yearsTo = useMemo(() => {
    var _props$value$from, _props$value3;
    return generateYears((_props$value$from = (_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.from) !== null && _props$value$from !== void 0 ? _props$value$from : props.min, props.max);
  }, [(_props$value4 = props.value) === null || _props$value4 === void 0 ? void 0 : _props$value4.from]);
  const onFromYearChange = from => {
    props.onChange(_objectSpread(_objectSpread({}, props.value), {}, {
      from
    }));
  };
  const onToYearChange = to => {
    props.onChange(_objectSpread(_objectSpread({}, props.value), {}, {
      to
    }));
  };
  return /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 10
    },
    children: [/*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          width: '100%',
          position: 'relative'
        }
      },
      "data-id": "from-year",
      children: /*#__PURE__*/_jsx(SearchDropdown, {
        optionList: yearsFrom,
        value: props.value.from,
        renderData: item => item ? item.toString() : '',
        onChange: onFromYearChange,
        maxItemsOverlay: 5,
        placeholder: 'From',
        disabled: props.disabled
      })
    }), /*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          width: '100%',
          position: 'relative'
        }
      },
      "data-id": "to-year",
      children: /*#__PURE__*/_jsx(SearchDropdown, {
        optionList: yearsTo,
        value: props.value.to,
        renderData: item => item ? item.toString() : '',
        maxItemsOverlay: 5,
        onChange: onToYearChange,
        placeholder: 'To',
        disabled: props.disabled
      })
    })]
  });
};
YearRangeSelect.defaultProps = {
  min: 1888,
  max: new Date().getFullYear() + 10
};